import styled from 'styled-components';

const Form = styled.form`
  width: 500px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 5px;
`;

export { Form };
